import React from 'react'
import { Button, Chip, FormControlLabel, Grid, Switch, Typography } from '@material-ui/core'
import MUIDataTable from 'mui-datatables'
import MonetizationOnIcon from '@material-ui/icons/MonetizationOn'
import TouchAppIcon from '@material-ui/icons/TouchApp'

// components
import PageTitle from '../../PageTitle/PageTitle'
// data
import { FormLoader } from '../../../Loader/FormLoader'
import { FormattedMessage, FormattedNumber, useIntl } from 'react-intl'
import Configuration from '../../../../Services/Api/Configuration'
import SubscriptionServices from '../../../../Services/Consumers/SubscriptionServices'
import { filterData, parseLocaleNumber } from '../../../../utils/helpers'
import {
  exportFiltersPayload,
  ReportFiltersPayload
} from '../../../../Services/Payloads/AuthenticatedUserPayload'
import { useKeycloak } from '@react-keycloak/web'
import { useStyles } from './Styles'
import Moment from 'react-moment'

let { User_Config } = Configuration
export default function PlansContent ({ handleNotificationCall, locale }) {
  let classes = useStyles()
  const intl = useIntl()
  const { keycloak } = useKeycloak()
  const [count, setCount] = React.useState(0)
  const [currentFilter, setCurrentFilter] = React.useState(null)
  const rowsPerPage = User_Config.userPlansReportLimit
  const [SortOrder, setSortOrder] = React.useState({})
  const [data, setData] = React.useState(['Loading Data...'])
  const [loadedData, setLoadedData] = React.useState([])
  const [isLoading, setIsLoading] = React.useState(false)

  const columns = [
    {
      name: 'id',
      label: intl.formatMessage({ id: 'Users.List.Table.ID' }),
      options: {
        filter: false,
        display: 'false',
        viewColumns: false
      }
    },
    {
      name: 'title',
      label: intl.formatMessage({ id: 'Plans.List.Table.Title' }),
      options: {
        filterType: 'textField',
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Plans.List.Table.Title'/>:
                <span>{v}</span>
              </div>
            )
          }
        }
      }
    },
    {
      name: 'description',
      label: intl.formatMessage({ id: 'Plans.List.Table.Description' }),
      options: {
        filter: false,
        display: 'false',
        customBodyRenderLite: (dataIndex) => {
          return data[dataIndex] && <div className={classes.categoryDesc} dangerouslySetInnerHTML={{
            __html: data[dataIndex].description
          }}></div>
        }
      }
    },
    {
      name: 'services',
      label: intl.formatMessage({ id: 'Plans.List.Table.Services' }),
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return data[dataIndex] && ((data[dataIndex].services && data[dataIndex].services.length) ?
            data[dataIndex].services.map((service) => (
              <div key={service.id} className={classes.priceChipWrapper}>
                <Chip
                  icon={<TouchAppIcon/>}
                  label={service.title}
                />
              </div>
            )) : '')
        }
      }
    },
    {
      name: 'prices',
      label: intl.formatMessage({ id: 'Plans.List.Table.Prices' }),
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return data[dataIndex] && ((data[dataIndex].prices && data[dataIndex].prices.length) ?
            data[dataIndex].prices.map((planPrice) => (
              <div key={planPrice.id} className={classes.priceChipWrapper}>
                <Chip
                  icon={<MonetizationOnIcon/>}
                  label={
                    <div className={classes.priceChip}>
                      <strong><FormattedNumber value={parseLocaleNumber(planPrice.price)}/> <FormattedMessage id='egp'/></strong>
                      <FormattedMessage id={`Services.List.Table.Prices.${planPrice.price_duration}`}/>
                    </div>
                  }
                />
              </div>
            )) : '')
        }
      }
    },
    {
      name: 'subscriptions_count',
      label: intl.formatMessage({ id: 'Plans.List.Table.SubscriptionsCount' }),
      options: {
        filter: false
      }
    },
    {
      name: 'active',
      label: intl.formatMessage({ id: 'Plans.List.Table.active' }),
      options: {
        filterOptions: {
          names: [0, 1],
          renderValue: v => !!v ? intl.formatMessage({ id: 'Services.List.Table.Active.Option.Active' }) : intl.formatMessage({ id: 'Services.List.Table.Active.Option.inActive' })
        },
        customFilterListOptions: {
          render: (v) => {
            return (
              <div className={classes.FilterChip}>
                <FormattedMessage id='Plans.List.Table.active'/>:
                <span>{!!v ? intl.formatMessage({ id: 'Services.List.Table.Active.Option.Active' }) : intl.formatMessage({ id: 'Services.List.Table.Active.Option.inActive' })}</span>
              </div>
            )
          }
        },
        customBodyRender: (value, tableMeta, updateValue) => {
          return (
            !!tableMeta && tableMeta.rowData[0] &&
            <FormControlLabel
              label={value ? intl.formatMessage({ id: 'Services.List.Table.Active.Option.Active' }) : intl.formatMessage({ id: 'Services.List.Table.Active.Option.inActive' })}
              value={value ? true : false}
              control={
                <Switch color="primary" checked={value} value={value ? true : false}/>
              }
              onChange={(event) => {
                let servicesIds = (!!tableMeta.rowData[3] && !!tableMeta.rowData[3].length) ?
                  tableMeta.rowData[3].map(service => service.id) : []
                let serviceObj = {
                  'title': tableMeta.rowData[1],
                  'description': tableMeta.rowData[2],
                  'services': servicesIds,
                  'prices': tableMeta.rowData[4],
                  'active': !JSON.parse(event.target.value)
                }
                updateValue(!JSON.parse(event.target.value))
                activeStatus(tableMeta.rowData[0], serviceObj, !JSON.parse(event.target.value), updateValue)
              }}
            />
          )
        }
      }
    },
    {
      name: 'created_at',
      label: intl.formatMessage({ id: 'Plans.List.Table.CreatedDate' }),
      options: {
        filter: false,
        customBodyRenderLite: (dataIndex) => {
          return data[dataIndex] &&
            <Moment locale={locale === 'ar' ? 'ar-ly' : 'en-us'} format="Do MMMM YYYY h:mm a">{data[dataIndex].created_at}</Moment>
        }
      }
    }
  ]

  const updateLoadedData = (planId, newActiveValue) => {
    let newData = loadedData
    newData.forEach((planData) => {
      planData.forEach((plan) => {
        if (planId === plan.id) {
          plan.active = !!newActiveValue ? 1 : 0
        }
      })
    })
    setLoadedData(newData)
  }

  const activeStatus = (planId, updatedServiceObject, newActiveValue, updateValue) => {
    if (!!keycloak?.authenticated) {
      SubscriptionServices.updatePlan(planId, updatedServiceObject, {
        headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` }
      }, setIsLoading).then((result) => {
        if ((!!result.response && result.response.status !== 200) || !result) {
          handleNotificationCall({
            type: 'defence',
            message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
            color: 'error'
          }, 'error')
          updateValue(!newActiveValue)
        } else {
          if (!!result && !!result.data && !!result.data.data) {
            handleNotificationCall({
              type: 'done',
              message: intl.formatMessage({
                id: newActiveValue ? 'Services.List.Table.Active.Success' :
                  'Services.List.Table.inActive.Success'
              }),
              color: 'success'
            }, 'success')
            updateLoadedData(planId, newActiveValue)
          } else {
            handleNotificationCall({
              type: 'defence',
              message: intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' }),
              color: 'error'
            }, 'error')
            updateValue(!newActiveValue)
          }
        }
      })
    }
  }
// get data
  const getUsersListData = async (page) => {
    await xhrRequest(page)
  }
  // mock async function
  const xhrRequest = (page, sortOrder = {}, clear, sortFieldName = '') => {
    if (!!keycloak?.authenticated) {

      setIsLoading(true)
      setSortOrder(sortOrder)

      if (!!loadedData[page] && !!loadedData[page].length && !clear) {
        setData(loadedData[page])
        setIsLoading(false)
      } else {
        SubscriptionServices.getPlansReport({
          headers: { 'Authorization': `Bearer ${keycloak?.token ?? ''}` },
          params: filterData(ReportFiltersPayload(page, rowsPerPage, currentFilter, sortOrder || SortOrder))
        }).then((result) => {
          if ((!!result.response && result.response.status !== 200) || !result) {
            let message = intl.formatMessage({ id: 'BasicInfo.FormErrorAlert' })
            if (result.response.data && result.response.data.status) {
              if (result.response.status === 403) {
                setData([])
                message = intl.formatMessage({ id: 'BasicInfo.AccessDeniedAlert' })
              } else if (result.response.data.status.errors && result.response.status === 422) {
                message = result.response.data.status.errors
              } else if (result.response.data.status.message) {
                message = result.response.data.status.message
              }
            }
            handleNotificationCall({
              type: 'defence',
              message: message,
              color: 'error'
            }, 'error')
            // setUserCompaniesFailure(true)
          } else {
            if (!!result && !!result.data && !!result.data.data) {
              let newData = result.data.data

              let sortField = sortOrder.name
              let sortDir = sortOrder.direction

              if (sortField) {
                newData = newData.sort((a, b) => {
                  if (a[sortField] < b[sortField]) {
                    return 1 * (sortDir === 'asc' ? -1 : 1)
                  } else if (a[sortField] > b[sortField]) {
                    return -1 * (sortDir === 'asc' ? -1 : 1)
                  } else {
                    return 0
                  }
                })
              }
              setData(newData)
              let prevData = loadedData
              prevData[page] = newData
              setLoadedData(prevData)
              setCount(result.data.meta.total)
            }
          }
        }).then(() => {
          setIsLoading(false)
        })
      }
    }
  }
  const sort = (page, sortOrder) => {
    setSortOrder(sortOrder)
    let sortField = sortOrder.name
    let sortDir = sortOrder.direction
    let newData = data

    if (sortField) {
      if ('subscriptions_count' === sortField) {
        setData([])
        xhrRequest(1, sortOrder, true)
      } else {
        newData = newData.sort((a, b) => {
          if (a[sortField] < b[sortField]) {
            return 1 * (sortDir === 'asc' ? -1 : 1)
          } else if (a[sortField] > b[sortField]) {
            return -1 * (sortDir === 'asc' ? -1 : 1)
          } else {
            return 0
          }
        })
        setData(newData)
      }
    }
    // xhrRequest(page, sortOrder)
  }
  React.useEffect(() => {
      getUsersListData(1)
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [])

  const changePage = (page, sortOrder) => {
    xhrRequest(++page, sortOrder)
  }
  const changeFilter = (applyFilters) => {
    setLoadedData([])
    let filterList = applyFilters()
    let filters = {}
    filterList.forEach((filterItem, index) => {
      if (!!filterItem.length) {
        if ('active' === columns[index].name) {
          filters[columns[index].name] = !!filterItem[0] ? 1 : 0
        } else if (filterItem[0].length >= 1) {
          filters[columns[index].name] = filterItem[0]
        }
      }
    })
    setCurrentFilter(filters)
  }

  React.useEffect(() => {
      if (!!currentFilter) {
        xhrRequest(1, SortOrder, true)
      }
    }, // eslint-disable-next-line react-hooks/exhaustive-deps
    [currentFilter])

  const options = {
    filter: true,
    filterType: 'dropdown',
    responsive: 'simple',
    selectableRowsHeader: false,
    selectableRowsHideCheckboxes: true,
    serverSide: true,
    count: count,
    search: false,
    rowsPerPage: rowsPerPage,
    rowsPerPageOptions: [],
    sortOrder: SortOrder,
    confirmFilters: true,
    onDownload: (buildHead, buildBody, columns, data) => {
      SubscriptionServices.exportPlansReport({
        headers: {
          'Authorization': `Bearer ${keycloak?.token ?? ''}`,
          'Accept': 'application/octet-stream'
        },
        params: filterData(exportFiltersPayload(currentFilter)),
        responseType: 'blob'
      }).then((result) => {
        if (result.data) {
          const type = result.headers['content-type']
          const blob = new Blob([result.data], { type: type, encoding: 'UTF-8' })
          const url = window.URL.createObjectURL(blob)
          const link = document.createElement('a')
          link.href = url
          const contentDisposition = result.headers['content-disposition']
          let fileName = `${intl.formatMessage({ id: 'PageTitle.PlansReport' })}.xlsx`
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="(.+)"/)
            if (fileNameMatch.length === 2)
              fileName = fileNameMatch[1]
          }
          link.setAttribute('download', fileName) //or any other extension
          document.body.appendChild(link)
          link.click()
          link.remove()
          window.URL.revokeObjectURL(url)
        }
      })
      return false
    },
    customFilterDialogFooter: (currentFilterList, applyNewFilters) => {
      return (
        <div className={classes.ApplyFilterWrapper}>
          <Button color='primary' variant="contained" onClick={() => changeFilter(applyNewFilters)}>
            <FormattedMessage id='Users.List.Table.ApplyFilters'/></Button>
        </div>
      )
    },
    onFilterChange: (column, filterList, type) => {
      if (type === 'chip') {
        setLoadedData([])
        let newFilters = () => (filterList)
        console.log('updating filters via chip')
        changeFilter(newFilters)
      }
    },
    textLabels: {
      body: {
        noMatch: intl.formatMessage({ id: 'Users.List.Table.NoMatching' }),
        toolTip: intl.formatMessage({ id: 'Users.List.Table.Sort' }),
        columnHeaderTooltip: column => intl.formatMessage(
          { id: 'Users.List.Table.SortFor' },
          { label: column.label })
      },
      pagination: {
        next: intl.formatMessage({ id: 'Users.List.Table.NextPage' }),
        previous: intl.formatMessage({ id: 'Users.List.Table.PreviousPage' }),
        rowsPerPage: intl.formatMessage({ id: 'Users.List.Table.RowsPerPage' }),
        displayRows: intl.formatMessage({ id: 'Users.List.Table.Of' })
      },
      toolbar: {
        search: intl.formatMessage({ id: 'Users.List.Table.Search' }),
        downloadCsv: intl.formatMessage({ id: 'PaymentRequests.List.Table.Download' }),
        print: intl.formatMessage({ id: 'Users.List.Table.Print' }),
        viewColumns: intl.formatMessage({ id: 'Users.List.Table.ViewColumns' }),
        filterTable: intl.formatMessage({ id: 'Users.List.Table.FilterTable' })
      },
      filter: {
        all: intl.formatMessage({ id: 'Users.List.Table.All' }),
        title: intl.formatMessage({ id: 'Users.List.Table.FILTERS' }),
        reset: intl.formatMessage({ id: 'Users.List.Table.RESET' })
      },
      viewColumns: {
        title: intl.formatMessage({ id: 'Users.List.Table.ShowColumns' }),
        titleAria: intl.formatMessage({ id: 'Users.List.Table.ShowHideColumns' })
      }
    },
    onTableChange: (action, tableState) => {
      switch (action) {
        case 'changePage':
          changePage(tableState.page, tableState.sortOrder)
          break
        case 'sort':
          sort(tableState.page, tableState.sortOrder)
          break
        default:
          break
      }
    }
  }
  return (
    <>
      <PageTitle title={<FormattedMessage id='PageTitle.PlansReport'/>}/>
      <Grid container spacing={4}>
        <Grid item xs={12} className={classes.TableWrapper}>
          {isLoading && <FormLoader loading={true}/>}
          <MUIDataTable
            title={
              <Typography variant="h6">
                <FormattedMessage id='PageTitle.PlansReport'/>
              </Typography>
            }
            data={data}
            columns={columns}
            options={options}
          />
        </Grid>
      </Grid>
    </>
  )
}
